<div class="ambassador-referral {{ theme?.root }} bg-cover bg-no-repeat bg-center">
  <div class="ambassador-referral container {{ theme?.container }}">
    <div class="flex flex-col lg:flex-row items-center">
      <div class="ambassador-referral-content pb-v-spacing sm:p-v-spacing {{ image && image.url ? 'lg:w-1/2' : ''}}">
        @if (referralTitle) {
          <div class="wysiwyg pb-4 referral-title" [innerHTML]="referralTitle"></div>
        }
        @if (referralContent) {
          <div class="wysiwyg pb-8 referral-content" [innerHTML]="referralContent"></div>
        }
        @if (dropdownTitle && dropdown.length > 0) {
          <vision-dropdown [dropdownData]="dropdownData"
          (changeEvent)="handleCampaignChange($event)"></vision-dropdown>
        }
      </div>
      @if (ambassadorRightContent) {
        <div class="right-content m-auto w-full lg:w-1/2 xs:p-v-spacing py-v-spacing">
          <div class="wysiwyg" [innerHTML]="ambassadorRightContent"></div>
        </div>
      }
      <!-- Note: this image component will be deprecated -->
      @if (!ambassadorRightContent && image && image.url) {
        <div class="ambassador-referral-image pt-v-spacing sm:p-v-spacing lg:w-1/2">
          @if (image && image.url) {
            <img
              src="{{ imgixService.buildImgixUrl(image.url) }}"
              [alt]="image.altText ? image.altText : ''"
              width="507"
              height="534"
              />
          }
        </div>
      }
    </div>
  </div>
</div>
